import { APP_BUILD_REVISION, APP_VERSION } from "./app-version";

/**
 * Human-readable build label for VersionDisplay (timestamp + revision when known).
 */
export function getAppVersionLabel(): string {
  const rev = APP_BUILD_REVISION as string;
  const ver = APP_VERSION as string;
  if (!rev || rev === "unknown") {
    return ver;
  }
  return `${ver} · ${rev}`;
}
